export default __webpack_public_path__ + "static/property-7-353x230-81b999caa80deba9e0033182c6601661.jpg";